var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.config.type,"icon":_vm.config.icon,"size":"small","disabled":_vm.disabled},on:{"click":function($event){_vm.bus.$emit('record-template-dialog', _vm.record)}}},[_vm._v(_vm._s(_vm.record.statusValue))])}
var staticRenderFns = []

export { render, staticRenderFns }